import ExpenseForm from "./Form";
import ExpensesList from "./List";

export default function ExpensesPage(props: any) {
  return (
    <div className="content_page">
      {(!props.action || props.action === "list") && <ExpensesList />}

      {props.action && ["create", "edit"].includes(props.action) && (
        <ExpenseForm action={props.action} />
      )}
    </div>
  );
}
